<script setup lang="ts">
import { ref,reactive,onMounted,onBeforeUnmount,toRefs,watch,computed } from 'vue'
import CustomList from "../../../../compositions/CustomList.vue";
import ModalDialog from "../../../../compositions/ModalDialog.vue";
import SearchBox from "../../../../compositions/SearchBox.vue";
import TextBox from "../../../../compositions/TextBox.vue";
import SelectBox from "../../../../compositions/SelectBox.vue";
import CheckBox from "../../../../compositions/CheckBox.vue";
import OrderMedicineComponent from '../../../Common/OrderMedicineComponent.vue';
import OrderMedicineTmpComponent from '../../../Common/OrderMedicineTmpComponent.vue';
import PharmacyMedicineEditComponent from "../../../Common/PharmacyMedicineEditComponent.vue";
import CartComponent from "../../../Common/CartComponent.vue";
import config from "../../../../config.js";
import { errorAlert,confirmAlert,successAlert } from "../../../../plugins/alert";
import { initialOrderData } from "../../../../plugins/order";
import axios from '../../../../plugins/axios.ts';
import moment from "moment";
import { useOrderStore } from '../../../../stores/order';
import HelpAction from '../../../../compositions/HelpAction.vue';
import Breakpoint from '../../../../compositions/Breakpoint.vue';
import { deepCopy } from '../../../../plugins/utility.ts';

const order = useOrderStore();

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    pharmacyWholesalers:{
      type:Array,
      required:true,
    },
    params:{
      type:Object,
      default:() => {
        return null;
      }
    },
    identityId: {
      typ:Number,
      default:() => {
        return 0;
      }
    },
    isVisible:{
        type:Boolean,
        default: () => {
            return false;
        }
    },
})

const refreshDateTime = ref('');
const listHeight = ref(0);
const headerRef = ref();
const submitRef = ref();
const changeListHeight = () => {
  if (typeof headerRef.value !== 'undefined') {
    listHeight.value = window.innerHeight - document.getElementById('header').clientHeight - document.getElementById('footer').clientHeight - document.getElementById('order_header').clientHeight - headerRef.value.clientHeight - 5;
    if (typeof submitRef.value !== 'undefined' && isEditedCheck()) {
      listHeight.value -= (submitRef.value.clientHeight - document.getElementById('footer').clientHeight - 5);
    }
    if (listHeight.value < 200) {
      listHeight.value = 200;
    }
  }
}

const { isVisible,identityId } = toRefs(props);
const inputRefs = ref();
const listOrderRef = ref();
const listOrderTmpRef = ref();
const searchWord = ref('');
const prescriptMaxDaysCheck = ref(false);
const pharmacyTagList = reactive([]);
const pharmacyTagOptions = reactive([]);
const isAllLoading = ref(false);
const medicineIds = reactive([]);
const medicineOptions = reactive([]);
const handler = (name:string,value:Object,eof:Boolean=false) => {
  if (name == 'item') {
  }
}
const orderFields = ref([
  {field_name: '採用品', field_key: 'product_name', width: '15%', align: 'text-left', sorted: true},
  {field_name: '実在庫数', field_key: 'real_stock_number', width: '10%', align: 'text-center', sorted: true},
  {field_name: '仮在庫数', field_key: 'stock_number', width: '10%', align: 'text-center', sorted: true},
  {field_name: '予測必要数', field_key: 'prescript_predict_quantity_number', width: '9%', align: 'text-center'},
  {field_name: '', field_key: 'action_medicine_order', width: '45%', align: 'text-center'},
  {field_name: '', field_key: 'action_status', width: '6%', align: 'text-center'},
  {field_name: '', field_key: 'action_setting', width: '5%', align: 'text-center'},
]);
const orderOptionFields = reactive({
  'search_word' : searchWord.value,
  'page_size' : 30,
  'is_auto' : 1,
  'is_prescript_max_days':(prescriptMaxDaysCheck.value ? 1 : null),
  'tags':pharmacyTagList,
  'medicine_ids':[],
});
const orderTmpFields = ref([
  {field_name: '採用品', field_key: 'product_detail_name', width: '15%', align: 'text-left', sorted: true},
  {field_name: '', field_key: 'stock_type', width: '3%', align: 'text-left', sorted: false},
  {field_name: '実在庫数<br>', field_key: 'real_stock_number', width: '5%', align: 'text-center', sorted: true},
  {field_name: '仮在庫数<br>', field_key: 'stock_number', width: '5%', align: 'text-center', sorted: true},
  {field_name: '取引先', field_key: 'target_name', width: '15%', align: 'text-left', sorted: false},
  {field_name: '単価', field_key: 'current_package_price', width: '5%', align: 'text-center', sorted: true},
  {field_name: '取引数量<br>', field_key: 'order_number', width: '5%', align: 'text-center', sorted: false},
  {field_name: '取引金額<br>', field_key: 'total_price', width: '7%', align: 'text-center', sorted: false},
  {field_name: '譲受譲渡日<br>', field_key: 'assignment_date', width: '5%', align: 'text-center', sorted: false},
  {field_name: '', field_key: 'action', width: '5%', align: 'text-center', sorted: false},
]);
const listSearch = (force = false,delay = 0) => {
  orderOptionFields.search_word = searchWord.value;
  orderOptionFields.medicine_ids = medicineIds;
  orderOptionFields.is_prescript_max_days = (prescriptMaxDaysCheck.value ? 1 : null);
  orderOptionFields.tags = pharmacyTagList;
  if (force == false) {
    listOrderRef.value.resetItem(delay);
  } else {
    listOrderRef.value.resetForceItem(delay);
  }
}
const onPrescriptMaxDaysChange = (value) => {
  prescriptMaxDaysCheck.value = value;
  listSearch();
}

const editStatusChange = (pharmacyMedicineId,status) => {
  let item = listOrderRef.value.getItemById(pharmacyMedicineId);
  order.delete_data('is_auto',pharmacyMedicineId);
  order.delete_data('is_auto_pack',pharmacyMedicineId);
  listOrderRef.value.deleteItem(item);
  order.order_count--;
  if (status == 'is_hold') {
    order.order_hold_count++;
  }
}
const getSelectItem = (pharmacyMedicineId) => {
  let result = null;
  let list = listOrderRef.value.getItems();
  for (let i=0;i<list.length;i++) {
    for (let j=0;j<list[i].pharmacy_medicine_list.length;j++) {
      if (list[i].pharmacy_medicine_list[j].id == pharmacyMedicineId) {
        result = list[i].pharmacy_medicine_list[j];
        break;
      }

    }
    if (result !== null) {
      break;
    }
  }
  return result;
}

const editOrderCheckChange = (value,option) => {
  let edit_record = order.search_data('is_auto',option.id);
  if (edit_record != null) {
    if (option.type == 'is_telephone') {
      edit_record.is_telephone = value;
    } else {
      edit_record.commited = value;
    }
    order.save_data('is_auto',edit_record);
  } else {
    let selItem = getSelectItem(option.id);
    let record = initialOrderData(selItem);
    if (option.type == 'is_telephone') {
      record.is_telephone = value;
    } else {
      record.commited = value;
    }
    record.lot_number = selItem.predict_quantity_lot_number;
    order.save_data('is_auto',record);
  }
}
const editOrderSelectChange = (value,label,option) => {
  let edit_record = order.search_data('is_auto',option.id);
  if (edit_record != null) {
    if (option.type == 'medicine') {
      edit_record.medicine_id = value;
    } else if (option.type == 'wholesaler') {
      edit_record.wholesaler_id = value;
      edit_record.wholesaler_name = label;
    }
    order.save_data('is_auto',edit_record);
  } else {
    let selItem = getSelectItem(option.id);
    let record = initialOrderData(selItem);
    record.lot_number = selItem.predict_quantity_lot_number;
    if (option.type == 'medicine') {
      record.medicine_id = value;
    } else if (option.type == 'wholesaler') {
      record.wholesaler_id = value;
      record.wholesaler_name = label;
    }
    order.save_data('is_auto',record);
  }
}
const editOrderTextChange = (value,option) => {
  let edit_record = order.search_data('is_auto',option.id);
  if (edit_record != null) {
    edit_record.lot_number = Number(value);
    order.save_data('is_auto',edit_record);
  } else {
    let selItem = getSelectItem(option.id);
    let record = initialOrderData(selItem);
    record.lot_number = Number(value);
    order.save_data('is_auto',record);
  }
}
const onEnterOrderText = (value,option) => {
  let nextIndex = 0;
  for (let i=0;i<inputRefs.value.length;i++) {
    if (inputRefs.value[i].$refs.inputElement.dataset.identityId == option.id) {
      nextIndex = i + 1;
      break;
    }
  }
  if (inputRefs.value.length > nextIndex) {
    inputRefs.value[nextIndex].$refs.inputElement.focus();
  }
}

const onSearchWordChange = (value) => {
  searchWord.value = value;
}
const onSearchWordEnter = (value) => {
  searchWord.value = value;
  listSearch();
}
const domComplete = () => {
  //手動追加したものは自動で１ロットで新規追加する
  if (addMedicineIds.length > 0) {
    for (let i=0;i<addMedicineIds.length;i++) {
      let item = getSelectItem(addMedicineIds[i]);
      if (item != null) {
        let record = initialOrderData(item);
        record.lot_number = 1;
        order.save_data('is_auto',record);
      }
    }
  }
  addMedicineIds.splice(0);
  //スピードアップのために総数はリストからとらないようにしたので代入しないようにする
  //order.order_count = listOrderRef.value.getItemAllCount();
  allCheckDomComplete();
  //予測数が変更になっている場合は上書きする(現在の設定値と予測値で比べて予測値の方が多い場合は上書き) ※20250409　外用薬等予測値より分かっていて少なく発注するものもあるので、在庫数がマイナスになっているものだけを対象にするように修正
  let list = listOrderRef.value.getItems();
  for (let i=0;i<list.length;i++) {
    if (list[i].real_stock_number < 0) {
      for (let j=0;j<list[i].pharmacy_medicine_list.length;j++) {
        let edit_record = order.search_data('is_auto',list[i].pharmacy_medicine_list[j].id);
        if (edit_record != null) {
          edit_record.lot_number = list[i].pharmacy_medicine_list[j].predict_quantity_lot_number;
          order.save_data('is_auto',edit_record);
        }
      }
    }
  }
}
const editSettingComplete = () => {
  listSearch(false,config.LIST_DELAY);
}

const isLoadingDialog = ref(false);
const isUpdatePharmacyStockConfirmDialog = ref(false);
//納品日のデフォルトは空
const deliveryDate = ref('');
let monthEnd = moment().endOf('month');
//月末に近づくとアラートを出す
const deliveryDateAlert = ref('');
if (monthEnd.diff((new Date()),'days') <= config.ORDER_LIMIT_ALERT_DAY) {
  deliveryDateAlert.value = config.ORDER_LIMIT_ALERT_DAY_MESSAGE.replace('${end_date}',monthEnd.diff((new Date()),'days'));
}
const showUpdatePharmacyStockConfirmDialog = () => {
  deliveryDate.value = '';
  //リスト更新
  listOrderTmpRef.value.resetItem();
  isUpdatePharmacyStockConfirmDialog.value = true;
}
const closeUpdatePharmacyStockConfirmDialog = () => {
  isUpdatePharmacyStockConfirmDialog.value = false;
}
const closeUpdatePharmacyStockConfirm = async () => {
  if (order.edit_order_pack_data.length > 0 || order.edit_order_data.length > 0) {
    let result = await confirmAlert('編集中の内容を削除してもよろしいですか？');
    if (result.isConfirmed) {
      closePharmacyStock();
    }
  } else {
    closePharmacyStock();
  }
}
const closePharmacyStock = async () => {
  order.reset_data('is_auto');
  listSearch();
}

const closeUpdatePharmacyStock = () => {
  order.reset_data('is_auto');
  isUpdatePharmacyStockConfirmDialog.value = false;
  listSearch();
}
const onDeliveryDateChange = (value) => {
  deliveryDate.value = value;
}
const createOrderParams = (type) => {
  return order.create_order_params(deliveryDate.value,true);
}
const updatePharmacyStock = async (type) => {
  isLoadingDialog.value = true;
  let params = createOrderParams(type);
  try {
    const response = await axios(props.apis.pharmacy_order_update,{method:"post",data:params});
    if (response.data.status == 200) {
      //納品待ちを増やす
      successAlert('発注予約しました。しばらくお待ちください。');
      //order.order_wait_count += response.data.data.update_count;
      closeUpdatePharmacyStock();
    }
  } finally {
    isLoadingDialog.value = false;
  }
}

const pharmacyMedicineEditIdentityId = ref(0);
const isEditPharmacyMedicineDialog = ref(false);
const showEditPharmacyMedicine = () => {
  pharmacyMedicineEditIdentityId.value++;
  isEditPharmacyMedicineDialog.value = true;
}
const closeEditPharmacyMedicine = () => {
  isEditPharmacyMedicineDialog.value = false;
}
const addMedicineIds = reactive([]);
const updateCompleteMedicine = (data) => {
  //採用品追加したものはList取得後に自動で１ロット入力で登録する
  addMedicineIds.splice(0);
  for (let i=0;i<data.length;i++) {
    addMedicineIds.push(data[i].id);
  }
  listSearch(false,config.LIST_DELAY);
  closeEditPharmacyMedicine();
}

watch(isVisible,(newValue, oldValue) => {
  if (newValue) {
    refreshDateTime.value = moment().format("YYYY-MM-DD HH:mm:ss");
    listSearch();
    setTimeout(changeListHeight,100);
  }
})
watch(identityId,(newValue, oldValue) => {
  listSearch(true);
})

const allCheckStart = () => {
  if (allCheckJudge()) {
    allCheck(false);
    return;
  }
  isAllLoading.value = true;
  listOrderRef.value.getItemAllLoad();
}
const allCheckDomComplete = () => {
  if (!isAllLoading.value) {
    return;
  }
  allCheck();
  isAllLoading.value = false;
}
const allCheck = (isFlg = true) => {
  let items = listOrderRef.value.getItems();
  for (let i=0;i<items.length;i++) {
    for (let j=0;j<items[i].pharmacy_medicine_list.length;j++) {
      //０のものはチェック付けない TODO
      let zeroFlg = false;
      if (isFlg && items[i].pharmacy_medicine_list[j].predict_quantity_lot_number == 0) {
        zeroFlg = true;
      } else if (isFlg) {
        let edit_record = order.search_data('is_auto',items[i].pharmacy_medicine_list[j].id);
        if (edit_record != null && edit_record.lot_number == 0) {
          zeroFlg = true;
          break;
        }
      }
      if (zeroFlg) {
        continue;
      }
      let exists = false;
      let edit_record = order.search_data('is_auto',items[i].pharmacy_medicine_list[j].id);
      if (edit_record != null) {
          edit_record.commited = isFlg;
          order.save_data('is_auto',edit_record);
          exists = true;
      }
      if (exists == false && isFlg == true) {
        let record = initialOrderData(items[i].pharmacy_medicine_list[j]);
        record.lot_number = items[i].pharmacy_medicine_list[j].predict_quantity_lot_number;
        record.commited = isFlg;
        order.save_data('is_auto',record);
      }
    }
  }
  for (let k=0;k<order.edit_order_data.length;k++) {
    //0の場合はチェックしない
    if (isFlg && order.edit_order_data[k].lot_number == 0) {
      continue;
    }
    let edit_record = deepCopy(order.edit_order_data[k]);
    edit_record.commited = isFlg;
    order.save_data('is_auto',edit_record);
  }
}
const orderPack = (orderPackData,deleted = false) => {
  let exists = false;
  let edit_record = order.search_data('is_auto_pack',orderPackData.pharmacy_medicine_id,'pharmacy_medicine_id',{pharmacy_id:orderPackData.pharmacy.id,medicine_group_id:orderPackData.medicine_group_id});
  if (edit_record != null) {
    if ((orderPackData.medicine_group_id == null && edit_record.medicine_group_id == null) || (orderPackData.medicine_group_id == edit_record.medicine_group_id)) {
      if (orderPackData.pharmacy.id == edit_record.pharmacy.id) {
        if (deleted == true) {
          order.delete_data('is_auto_pack',edit_record.pharmacy_medicine_id,'pharmacy_medicine_id',{pharmacy_id:orderPackData.pharmacy.id,medicine_group_id:orderPackData.medicine_group_id})
        } else {
          order.save_data('is_auto_pack',orderPackData,'pharmacy_medicine_id',{pharmacy_id:orderPackData.pharmacy.id,medicine_group_id:orderPackData.medicine_group_id});
        }
        exists = true;
      }
    }
  }
  if (deleted == false) {
    if (exists == false) {
      order.save_data('is_auto_pack',orderPackData,'pharmacy_medicine_id',{pharmacy_id:orderPackData.pharmacy.id,medicine_group_id:orderPackData.medicine_group_id});
    }
  }
}

const editCount = computed(() => {
  let result = 0;
  for (let i=0;i<order.edit_order_data.length;i++) {
    if (order.edit_order_data[i].commited && order.edit_order_data[i].lot_number && order.edit_order_data[i].wholesaler_id > 0) {
      result++;
    }
  }
  result += order.edit_order_pack_data.length;
  return result;
});
const editTotalPrice = computed(() => {
  let result = 0;
  for (let i=0;i<order.edit_order_data.length;i++) {
    if (order.edit_order_data[i].commited && order.edit_order_data[i].wholesaler_id > 0) {
      result += (order.edit_order_data[i].current_unit_price * order.edit_order_data[i].lot_number * order.edit_order_data[i].package_unit_number * order.edit_order_data[i].package_quantity_number);
    }
  }
  for (let i=0;i<order.edit_order_pack_data.length;i++) {
    result += (order.edit_order_pack_data[i].unit_price * order.edit_order_pack_data[i].number);
  }
  return result;
});
const isEditedCheck = (isCommited = true) => {
  let result = false;
  for (let i=0;i<order.edit_order_data.length;i++) {
    if (isCommited == false) {
      result = true;
      break;
    }
    if (order.edit_order_data[i].commited) {
      result = true;
      break;
    }
  }
  if (order.edit_order_pack_data.length > 0) {
    result = true;
  }
  return result;
}
const isEdited = computed(() => {
  return isEditedCheck();
});
const isEditStarted = computed(() => {
  setTimeout(changeListHeight,100);
  return isEditedCheck(false);
});
const isExpensiveAlertMessage = computed(() => {
  if (typeof listOrderTmpRef.value === 'undefined') {
    return '';
  }
  let message = '';
  let items = listOrderTmpRef.value.getItems();
  for (let i=0;i<items.length;i++) {
    if (items[i].expensive_alert) {
      message = '\\' + items[i].expensive_limit_unit_price.toLocaleString();
      break;
    }
  }
  return message;
});
const allCheckJudge = () => {
  if (typeof listOrderRef.value === 'undefined') {
    return false;
  }
  let items = listOrderRef.value.getItems();
  let result = false;
  for (let i=0;i<items.length;i++) {
    for (let j=0;j<items[i].pharmacy_medicine_list.length;j++) {
      for (let k=0;k<order.edit_order_data.length;k++) {
        if (items[i].pharmacy_medicine_list[j].id == order.edit_order_data[k].pharmacy_medicine_id) {
          if (order.edit_order_data[k].commited) {
            result = true;
          } else {
            result = false;
            break;
          }
        }
      }
    }
  }
  return result;
}
const isAllChecked = computed(() => {
  return allCheckJudge();
});
const displayLeave = () => {
}
onMounted(() => {
  setTimeout(changeListHeight,100);
  listSearch();
  window.addEventListener('resize', changeListHeight);
  window.addEventListener('beforeunload', displayLeave);
});
onBeforeUnmount(() => {
  window.removeEventListener('resize', changeListHeight);
  window.removeEventListener('beforeunload', displayLeave);
});

const tmpResponseComplete = (data) => {
  if (data['is_order_refresh']) {
    successAlert("前回画面更新後に別端末で発注作業が行われた可能性があります。重複発注にはご注意ください。");
  }
}
// 発注メニューの開閉管理status
const isOpen = ref(false);
// モバイルのみ表示する為のstatus
const isMobile: boolean = Breakpoint().isBelow('sm');

// 発注メニューの開閉管理
const toggleAccordion = () => {
  isOpen.value = !isOpen.value;;
}

///////////////////////////////
///////// 検索機能追 ///////////////
const onMedicineSelectChange = (values) => {
    medicineIds.splice(0);
    for (let i=0;i<values.length;i++) {
        medicineIds.push(values[i]);
    }
    listSearch();
}
///////////////////////////////////
//////////////////////////////////
// カート機能
//////////////////////////////////
const isCartDialog = ref(false);
const cartIdentityId = ref(0);
const showCartDialog = () => {
  cartIdentityId.value++;
  isCartDialog.value = true;
}
const closeCartDialog = () => {
  isCartDialog.value = false;
}
//////////////////////////////////
/////////////////////////////////
// タグ機能
/////////////////////////////////
const onPharmacyTagChange = (tags) => {
    pharmacyTagList.splice(0);
    for (let i=0;i<tags.length;i++) {
        pharmacyTagList.push(tags[i]);
    }
    listSearch();
}
const editPharmacyMedicineTagChange = (pharmacyMedicineId,tags) => {
  let item = listOrderRef.value.getItemById(pharmacyMedicineId);
  if (item != null) {
    item.tags = tags;
  }
}
/////////////////////////////////
///// 発注ダイアログ ////////////
const deleteOrderComplete = (item) => {
  if (item.stock_type == config.STOCK_TYPES['VAN']) {
    order.delete_data('is_auto',item.pharmacy_medicine_id);
  } else {
    order.delete_data('is_auto_pack',
                      item.pharmacy_medicine_id,
                      'pharmacy_medicine_id',
                    {
                      pharmacy_id:item.to_pharmacy_id,
                      medicine_group_id:item.medicine_group_id
                    }
                    );
  }
  listOrderTmpRef.value.deleteItem(item);
}
////////////////////////////////
</script>

<style scoped>
</style>
<template>
<div v-show="isVisible" class="relative">
  <div class="absolute top-2 left-2">
    <help-action
      help-key="order_list_help"
    ></help-action>
  </div>
  <div v-if="isMobile" class="w-auto md:w-full m-4 mb-0 md:flex items-center justify-end md:pt-9 md:p-2 border-b">
    <button  @click="toggleAccordion" class="flex items-center justify-center w-full py-2 px-4 text-gray-800 border-t border-x text-left">
      <img class="w-7 h-7" src="../../../../../public/images/icon/refine_search.png" alt="絞り込み検索">
      <div class="mx-3">絞り込み検索</div>
      <div class="pull-down-icon" :class="{ 'rotate-180': isOpen }"></div>
    </button>
  </div>

  <div ref="headerRef" class="md:pl-8 w-full md:flex flex-wrap items-center justify-between md:bg-gray-100 rounded">
    <div v-if="!isMobile">
      <a href="javascript:void(0)" @click="allCheckStart" class="flex items-center py-2.5 px-5 m-2 text-base font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-indigo-200 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">一括 <i class="fa-solid fa-check"></i>{{ isAllChecked ? '解除' : '' }}</a>
    </div>
    <div>
      <span class="text-3xl text-amber-500 cursor-pointer" @click="showCartDialog"><i class="fa-solid fa-cloud-arrow-down"></i></span>
    </div>
    <div v-if="!isMobile" class="pr-2">
      予測期間:{{ params.predict_date_from }}~{{ params.predict_date_to }}
    </div>
    <div v-if="!isMobile || isOpen" class="md:flex flex-row items-center">
      <div v-if="isMobile">
        <a href="javascript:void(0)" @click="allCheckStart" class="flex py-2.5 px-5 m-2 text-base font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-indigo-200 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">一括チェック{{ isAllChecked ? '解除' : '' }}</a>
      </div>
      <div class="m-1 flex flex-row items-center">
        <span class="text-xl mr-2"><i class="fa-solid fa-tag"></i></span>
        <select-box
            :api-url="apis.pharmacy_tag_list"
            :api-option-fields="{page_size:1000}"
            :on-change="onPharmacyTagChange"
            :value="pharmacyTagList"
            list-field-name="tag_name"
            :options="pharmacyTagOptions"
            :is-multi="true"
            place-holder="タグを選択"
            list-height="20em"
        ></select-box>
      </div>
      <div class="m-1">
        <check-box
          label="1日最大処方アラート"
          :value="prescriptMaxDaysCheck"
          :on-change="onPrescriptMaxDaysChange"
        ></check-box>
      </div>
      <div class="md:flex flex-row items-center">
        <div class="m-1">
            <select-box
                :api-url="apis.medicine_list"
                :api-option-fields="{relation_pharmacy:1,is_relation:1,page_size:20}"
                :on-change="onMedicineSelectChange"
                :value="medicineIds"
                list-field-name="product_detail_name"
                :options="medicineOptions"
                :is-multi="true"
                place-holder="採用品を選択"
                list-height="20em"
            ></select-box>
        </div>
        <div class="m-1">
          <search-box
              :search-word="searchWord"
              :on-change="onSearchWordChange"
              :on-enter="onSearchWordEnter"
              place-holder="採用品名を入力"
          ></search-box>
        </div>
        <div class="m-1">
          <a href="javascript:void(0)" @click="showEditPharmacyMedicine" class="text-sm md:text-base block text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 font-medium rounded-lg px-4 py-1 w-full sm:w-auto text-center md:ml-2">発注採用品追加</a>
        </div>
      </div>
    </div>
  </div>
  <div class="w-full">
    <custom-list
      ref="listOrderRef"
      :table-fields="orderFields"
      :option-fields="orderOptionFields"
      :api-url="apis.pharmacy_order_list"
      :height="listHeight + 'px'"
      :handler="handler"
      :dom-complete="domComplete"
    >
    <template v-slot:item="slotProps">
      <order-medicine-component
        ref="inputRefs"
        :apis="apis"
        type="is_auto"
        :pharmacy-wholesalers="pharmacyWholesalers"
        :identity-id="slotProps.item.id"
        :item="slotProps.item"
        :order-pack-values="order.edit_order_pack_data"
        :order-values="order.edit_order_data"
        :fields="orderFields"
        :edit-status-change="editStatusChange"
        :edit-order-select-change="editOrderSelectChange"
        :edit-order-check-change="editOrderCheckChange"
        :edit-order-text-change="editOrderTextChange"
        :on-enter-order-text="onEnterOrderText"
        :edit-order-pack-complete="orderPack"
        :edit-setting-complete="editSettingComplete"
        :edit-pharmacy-medicine-tag-change="editPharmacyMedicineTagChange"
      ></order-medicine-component>
    </template>
    </custom-list>
  </div>
  <div ref="submitRef" v-show="isEditStarted" class="fixed bottom-0 right-0 w-full md:flex items-center justify-end flex-wrap p-2 bg-gray-100 rounded text-sm md:text-base">
    <div class="m-1 w-1/4 md:w-auto	">品目：{{ editCount }}</div>
    <div class="m-1 w-1/2 md:w-auto	">合計金額：{{ editTotalPrice.toLocaleString() }}</div>
    <a href="javascript:void(0)" @click="closeUpdatePharmacyStockConfirm" class="text-center w-2/5 md:w-auto py-2.5 px-5 m-2 font-medium text-white focus:outline-none bg-red-800 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">キャンセル</a>
    <button v-show="isEdited" type="button" @click="showUpdatePharmacyStockConfirmDialog" class=" py-2.5 px-5 m-2 font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">発注</button>
  </div>
</div>
<modal-dialog
  :is-visible="isLoadingDialog"
  width="40%"
  :isLoading="true"
>
  <template v-slot:header>
  </template>
  <template v-slot:default>
  <div class="mb-6">
    処理中です。
  </div>
  </template>
</modal-dialog>
<modal-dialog
  :is-visible="isUpdatePharmacyStockConfirmDialog"
  width="80%"
  :close="closeUpdatePharmacyStockConfirmDialog"
>
  <template v-slot:header>
    発注
  </template>
  <template v-slot:default>
  <div class="mb-6">
    <div class="text-red-700">
      <span>※選択したはずの採用品が一覧にない場合は以下をご確認ください。</span><br>
      <span>・発注卸が未選択</span><br>
      <span>・発注数量が0</span><br>
      <span>・発注チェックしていない</span><br>
    </div>
    <custom-list
      ref="listOrderTmpRef"
      :table-fields="orderTmpFields"
      :api-url="apis.pharmacy_order_tmp_list"
      :option-fields="createOrderParams()"
      api-method="POST"
      font-size="0.8em"
      height="50vh"
      :response-complete="tmpResponseComplete"
    >
    <template v-slot:item="slotProps">
      <order-medicine-tmp-component
        :apis="apis"
        :identity-id="slotProps.item.id"
        :item="slotProps.item"
        :fields="orderTmpFields"
        :delete-item-complete="deleteOrderComplete"
      ></order-medicine-tmp-component>
    </template>
    </custom-list>
  </div>
  <div v-show="isExpensiveAlertMessage.length > 0" class="text-bold">
    <span>{{isExpensiveAlertMessage}}を越える発注があります。<img class="inline-block w-6 h-6" src="../../../../../public/images/icon/expensive_alert.png">マークの発注をご確認ください。</span>
  </div>
  <div class="mb-1">
    <p v-show="deliveryDateAlert.length > 0" class="text-red-700 font-bold">{{ deliveryDateAlert }}</p>
    <div class="flex flex-wrap items-center">
      <div class="m-1">納品日</div>
      <div class="m-1">
        <text-box
          place-holder="納品日を入力"
          :on-change="onDeliveryDateChange"
          :value="deliveryDate"
          type="date"
        ></text-box>
      </div>
    </div>
    <div class="m-1 text-red-600">※卸からの納品日を翌月付けにしたい場合は日付指定してください。</div>
  </div>
  <div class="flex items-center flex-row">
    <div class="m-1">品目：{{ editCount }}</div>
    <div class="m-1">合計金額：{{ editTotalPrice.toLocaleString() }}</div>
    <div class="m-1">
      <button type="button" @click="updatePharmacyStock('is_auto')" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">発注する</button>
    </div>
    <div class="m-1">
      <button type="button" @click="closeUpdatePharmacyStockConfirmDialog" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">キャンセル</button>
    </div>
  </div>
  </template>
</modal-dialog>
<modal-dialog
  :is-visible="isEditPharmacyMedicineDialog"
  width="95%"
  :close="closeEditPharmacyMedicine"
>
  <template v-slot:header>
    発注採用品追加
  </template>
  <template v-slot:default>
    <pharmacy-medicine-edit-component
      :apis="apis"
      :pharmacy-wholesalers="pharmacyWholesalers"
      :is-self="true"
      :identity-id="pharmacyMedicineEditIdentityId"
      :cancel="closeEditPharmacyMedicine"
      :updateComplete="updateCompleteMedicine"
    ></pharmacy-medicine-edit-component>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isCartDialog"
  width="95%"
  :close="closeCartDialog"
>
  <template v-slot:header>
    発注予約一覧
  </template>
  <template v-slot:default>
    <cart-component
      :apis="apis"
      :identity-id="cartIdentityId"
      :submit="closeCartDialog"
      :cancel="closeCartDialog"
    ></cart-component>
  </template>
</modal-dialog>
</template>

